/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Menu(props) {
    return (
        <SvgIcon {...props}>
            <rect y="6" width="10" height="2" />
            <rect y="2" width="10" height="2" />
            <rect y="10" width="10" height="2" />
        </SvgIcon>
    );
}

Menu.defaultProps = {
    viewBox: '0 0 10 16'
};

export default Menu;
